import React from 'react';
import Modal from '../modal/Modal';
import MatchForm from './form';
import AcceptModal from "../accept_modal/AcceptModal";
import { toast } from "react-toastify";
import MatchesApi from "../../api/Matches";
import MatchType from '../matchType/matchType';
import TeamsApi from "../../api/Teams";
import LeaguesApi from "../../api/Leagues";
import TournamentsApi from "../../api/Tournaments";
import RefereesApi from "../../api/Referees";
import CourtsApi from "../../api/Courts";
import * as moment from 'moment'
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { apiUrl } from '../../constants';

export default class Teams extends React.Component{
    tournaments = [];
    leagues = [];
    teams = [];
    matches = [];
    referee = [];
    constructor(){
        super();
        this.state = {
            showModal: false,
            data: {
                matches: []
            },
            modalTitle: "",
            selected: [],
            showAcceptModal: false,
            filterText: "",
            editMatchModal: false,
            tournaments: [],
            leagues: [],
            teams: [],
            referees: [],
            courts: [],
            filters: {
                type: "",
                tournament: 0,
                league: 0,
                minDate: moment(new Date().getDate(),"DD/MM/YYYY").subtract(4, 'days'),//moment().subtract(7, 'days'),
                maxDate: moment(new Date().getDate(),"DD/MM/YYYY").add(3, 'days'),//null,//moment().add(7, 'days'),
                team: 0
            },
            matchesFiltered: [],
            sheet: -1,
            sheets: [],
            totalSheets: 0
        };
    }

    componentWillMount = async() =>{
        let st = this.state;
        TeamsApi.getAvailable().then(r => {
            st.teams = r.data.response
            return RefereesApi.getAll(2)
        }).then(r => {
            st.referees = r.data.response;
           return TournamentsApi.getAll()
        }).then(r => {
            st.tournaments = r.data.response;
            return LeaguesApi.getAll()
        }).then(r => {
            st.leagues = r.data.response;
            this.leagues = r.data.response;
            return CourtsApi.getAll();
        }).then(r => {
            st.courts = r.data.response;
            return MatchesApi.getFiltered("minDate="+this.state.filters.minDate+"&maxDate="+this.state.filters.maxDate+"&sheet="+this.state.sheet);
        }).then(r => {
            st.data.matches = r.data.response.matches;
            st.sheets = r.data.response.sheets;
            st.matchesFiltered = st.data.matches;
            this.setState(st);
        });
    }

    edit(team){
        let st = {...this.state}
        st.modalTitle = "Editar";
        st.editMatchModal = true
        st.selected = team;
        var arr = [];
        arr.push({"label": this.state.teams.find(t => t.id === team.team1_id).team+" -- "+this.state.leagues.find(l => l.id === team.league1).name+" -- "+this.state.tournaments.find(t => t.id === team.tournament1).name,"value": team.team1_id,"league_id":team.league1,"tournament":this.state.tournaments.find(t => t.id === team.tournament1).name});
        st.selected.team1 = arr 
        var arr2 = [];
        arr2.push({"label": this.state.teams.find(t => t.id === team.team2_id).team+" -- "+this.state.leagues.find(l => l.id === team.league2).name+" -- "+this.state.tournaments.find(t => t.id === team.tournament2).name,"value": team.team2_id,"league_id":team.league2,"tournament": this.state.tournaments.find(t => t.id === team.tournament2).name});
        st.selected.team2 = arr2;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    closeEditMatchModal(){
        let state = {...this.state};
        state.editMatchModal = false;
        this.setState(state);
    }

    save(match){
        let state = {...this.state};
        match.status = 1;
        match.goals1 = 0;
        match.goals2 = 0;
        match.day = match.day.format("YYYY-MM-DD HH:mm:ss");
        MatchesApi.create(match).then(r => {
            if(state.data.matches===undefined)
                state.data.matches = []
            state.data.matches.push(r.data.response);
            state.matchesFiltered = state.data.matches;
            toast.success("Partido creado");
            this.setState(state);
        }).catch(err => toast.error("Error al crear juego"+err));
        this.closeModal();
    }

    saveEdit(match){
        match.day = match.day.format("YYYY-MM-DD HH:mm:ss");
        MatchesApi.edit(match, match.id).then(r => {
            toast.success("Datos actualizados");
            let state = {...this.state};
            state.editMatchModal = false;
            state.selected = [];
            let index = state.data.matches.findIndex(m => m.id === match.id);
            state.data.matches[index] = match;
            this.setState(state);
        }).catch(err => console.log(err));
    }

    create(){
        let st = this.state
        st.modalTitle = "Nuevo";
        st.showModal = true;
        st.selected = [];
        this.setState(st);
    }

    remove(){
        MatchesApi.delete(this.state.selected.id).then(res => {
            if(res.data.response){
                let state = {...this.state};
                state.data.matches.splice(state.data.matches.findIndex(t => t.id === state.selected.id),1);
                state.selected = [];
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Equipo eliminado");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        }).catch(e => toast.error(e.message));
    }

    delete(team){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = team;
        this.setState(state);
    }

    addPlayers(team){
        let state = {...this.state};
        state.addPlayersModal = true;
        state.selected = team;
        this.setState(state);
    }

    onTypeChange(d){
        let state = {...this.state};
        state.filters.type = d
        this.setState(state);
    }

    onMinDateChange(date){
        let state = {...this.state};
        state.filters.minDate = date;//.format("YYYY-MM-DD HH:mm:ss");
        this.setState(state);
    }
    onMaxDateChange(date){
        let state = {...this.state};
        state.filters.maxDate = date;//.format("YYYY-MM-DD HH:mm:ss");
        this.setState(state);
    }

    getFiltered(){
        let state = {...this.state};
        let str = "sheet=-1&";
        Object.keys(state.filters).forEach(function (key) {
            if(state.filters[key]){
                str = str +`${key}=${state.filters[key]}&`;
            }
        });
        MatchesApi.getFiltered(str).then(r => {
            state.data.matches = r.data.response.matches;
            state.sheets = r.data.response.sheets
            state.matchesFiltered = state.data.matches;
            this.setState(state);
        }).catch(err => console.log(err));
    }

    pagination(sheet){
        sheet-=1
        let st = {...this.state}
        let str = "sheet="+sheet+'&';
        Object.keys(st.filters).forEach(function (key) {
            if(st.filters[key]){
                if (key !== "tournament") str = str +`${key}=${st.filters[key]}&`;
            }
        });
        MatchesApi.getFiltered(str).then(r => {
            st.data.matches = r.data.response.matches;
            st.sheets.currentSheet = sheet
            st.matchesFiltered = st.data.matches;
            this.setState(st);
        });
    }

    totalSheets(){
        if(this.state.totalSheets==0){
            var ar=[];
            if(this.state.sheets==undefined){

            }else{
                for(var i=0;i<=this.state.sheets.total;i++){
                    ar.push(i+1);
                }
                return ar;
            }
        }
        return [];
    }

    render(){
        return(
            <div className="card-content">
                <div className="columns is-multiline">
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Tipo de juego</label>
                            <MatchType
                                onChange={(t) => this.onTypeChange(t)}
                                allTag={true}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Fecha inicial</label>
                            <Datepicker
                                selected={this.state.filters.minDate}
                                onChange={(date) => this.onMinDateChange(date)}
                                showMonthDropdown
                                withPortal
                                dateFormat="DD/MM/YYYY hh:mm a"
                                showTimeSelect={true}
                                timeIntervals={60} //10
                                className="input"
                                placeholderText="dd/mm/yyyy H:mm:ss"
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Fecha final</label>
                            <Datepicker
                                selected={this.state.filters.maxDate}
                                onChange={(date) => this.onMaxDateChange(date)}
                                showMonthDropdown
                                withPortal
                                dateFormat="DD/MM/YYYY hh:mm a"
                                showTimeSelect={true}
                                timeIntervals={60}//10
                                className="input"
                                placeholderText="dd/mm/yyyy H:mm"
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Equipo</label>
                            <select
                                className="input"
                                onChange={(e) => {
                                    let state = {...this.state};
                                    if(e.target.value!=""){
                                        let index = e.currentTarget.selectedIndex - 1;
                                        state.filters.team = e.target.value;
                                        // state.filters.league = this.state.teams[index].league_id;
                                        // state.filters.tournament = state.tournaments.find(t => t.id === state.leagues.find(l => l.id === state.filters.league).tournament_id).id;
                                        this.setState(state);
                                    }else{
                                        state.filters.team = ""
                                    }

                                }}
                            >
                                <option disabled={true} defaultValue={true}>Seleccionar...</option>
                                {this.state.teams && this.state.teams.map(l => {
                                    return (
                                        l.status != 0 &&
                                        <option key={l.id} value={l.id} defaultValue={l.id === this.state.filters.team}>
                                            {l.team}
                                        </option>
                                    )
                                })}
                                <option value="" key={0}>Todos</option>
                            </select>
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Torneo</label>
                            <select
                                className="input"
                                onChange={(e) => {
                                    let state = {...this.state};
                                    if(e.target.value!=""){
                                        let index = e.currentTarget.selectedIndex - 1;
                                        state.filters.tournament = this.state.tournaments[index].id;
                                        // state.filters.league = 0;
                                        // this.leagues = this.state.leagues.filter(l => l.tournament_id === state.filters.tournament);
                                        this.setState(state);
                                    }else{
                                        state.filters.tournament = ""
                                    }
                                }}
                            >
                                <option disabled={true} defaultValue={true}>Todos...</option>
                                {this.state.tournaments && this.state.tournaments.map(l => {
                                    return (
                                        <option key={l.id} defaultValue={l.id === this.state.filters.tournament}>
                                            {l.name}
                                        </option>
                                    )
                                })}
                                <option value="" key={0}>Todos</option>
                            </select>
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control">
                            <label className="label">Liga</label>
                            <select
                                className="input"
                                onChange={(e) => {
                                    if(e.target.value!=""){
                                        let state = {...this.state};
                                        let index = e.currentTarget.selectedIndex - 1;
                                        state.filters.league = this.leagues[index].id;
                                        this.setState(state);
                                    }
                                }}
                            >
                                <option key={0} value="" defaultValue={this.state.filters.league === 0}>Todas...</option>
                                {this.leagues && this.leagues.map(l => {
                                    return (
                                        <option key={l.id} defaultValue={l.id === this.state.filters.league}>
                                            {l.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control is-centered">
                            <label className="label">&nbsp;</label>
                            <a className="button is-outlined is-primary" onClick={(e) => this.getFiltered()}>Aplicar filtros</a>
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="control is-centered">
                            <label className="label">&nbsp;</label>
                            <a className="button is-outlined is-primary" onClick={(e) => this.create()}>Agregar juego</a><br/>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Juego</th>
                                <th>Local</th>
                                <th>vs</th>
                                <th>Visitante</th>
                                <th>Fecha</th>
                                <th>Liga</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.matchesFiltered && this.state.matchesFiltered.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <th>{d.type}</th>
                                        <td><Link to={'/Detalles/equipo/'+d.team1_id} >{(this.state.teams.find(t => t.id === d.team1_id))?this.state.teams.find(t => t.id === d.team1_id).team:"Equipo Eliminado"}</Link></td>
                                        <td>{d.goals1} vs {d.goals2}</td>
                                        <td><Link to={'/Detalles/equipo/'+d.team2_id} >{(this.state.teams.find(t => t.id === d.team2_id))?this.state.teams.find(t => t.id === d.team2_id).team :"Equipo Eliminado"}</Link></td>
                                        <td>{moment(d.day).format('DD-MMM-YY, h:mm:')}</td>
                                        <td>
                                            {this.state.leagues.find(l => l.id === d.league1) && this.state.leagues.find(l => l.id === d.league1).name+"-"}
                                            {
                                                (d.league1_id!=d.league2_id) ?
                                                (this.state.leagues.find(l => l.id === d.league2) ? this.state.leagues.find(l => l.id === d.league2).name : "Liga eliminada")
                                                : ''
                                            }
                                        </td>
                                        <td>
                                            {d.status == "1" && <a className="button is-primary" href={apiUrl+"/matches?match_id="+d.id+"&user_id="+localStorage.getItem("id")+"&cedula=1"} target="_blank">
                                                <span className="icon is-small">
                                                    <i className="fas fa-file-pdf"/>
                                                </span>
                                            </a>}
                                            <Link to={'/Resultado/juego/'+d.id} className="button">
                                                <i className="fas fa-check"/>
                                            </Link>
                                            {d.status == "1" && <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-edit"/>
                                                </span>
                                            </a>}
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-trash"/>
                                                </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                        {this.state.data.matches &&
                            <nav className="pagination is-rounded" role="navigation" aria-label="pagination">
                                <ul className="pagination-list">
                                    {this.state.matchesFiltered &&
                                        this.totalSheets().map(i=>{
                                            return(
                                            <li><a className={(i==Number.parseInt(this.state.sheets.currentSheet)+1)? "is-current pagination-link" : "pagination-link"} aria-label={"Goto page "+i}
                                                onClick={(e) => (i!=Number.parseInt(this.state.sheets.currentSheet)+1) && this.pagination(i)}>
                                                    {i}
                                                </a>
                                            </li>)
                                        })
                                    }
                                </ul>
                            </nav>
                        }
                        <br/><br/>
                    </div>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data.matches}
                    cancel={() => this.closeModal()}
                >
                    <MatchForm
                        teams = { this.state.teams }
                        courts = { this.state.courts }
                        referees = { this.state.referees }
                        selected = { this.state.selected }
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                    />
                </Modal>
                }
                {this.state.editMatchModal &&
                    <Modal
                        showModal={this.state.editMatchModal}
                        // match={this.state.selected}
                        modalTitle={'Editar juego'}
                        cancel={() => {
                            let state = {...this.state};
                            state.editMatchModal = false;
                            state.selected = [];
                            this.setState(state);
                        }}
                    >
                        <MatchForm
                            teams = { this.state.teams }
                            courts = { this.state.courts }
                            referees = { this.state.referees }
                            selected = { this.state.selected }
                            save={(t)=>this.saveEdit(t)}
                            cancel={() => {
                                let state = {...this.state};
                                state.editMatchModal = false;
                                state.selected = [];
                                this.setState(state);
                            }}
                        />
                    </Modal>
                }

                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    modalTitle={"Eliminar juego"}
                />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/matches/Matches.js